import { VendorBuyingAgreementBuyOpportunityPermissions } from '../../../components/Vendor';

export function BuyingAgreementBuyOpportunityPermissions() {
  return <VendorBuyingAgreementBuyOpportunityPermissions />;
}
